<template>
  <h2 class="titleStepForm">Member's Declaration</h2>
  <div class="">
    <p class="font-weight-500">
      Eastern Credit Union Cooperative Society Limited is
      required to comply with Anti- Money laundering and
      Combating Terrorist Financing legislation (Proceeds of
      Crime Act and Financial Obligations Regulations,
      Financial Intelligence Unit) and the Foreign Account Tax
      Compliance Act
    </p>
    <label
      for="hereByRd1"
      class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      :class="{
        'is-invalid':
          v$.form.personal9.hereRadioType_one.$error,
      }"
    >
      <template v-if="isEdit">
      <input
        type="checkbox"
        checked
        v-model="form.personal9.hereRadioType_one"
        value="True"
        class="inputRadioCstm d-none"
        id="hereByRd1"
      />
      </template>
      <template v-if="!isEdit">
      <input
        type="checkbox"
        v-model="form.personal9.hereRadioType_one"
        value="True"
        class="inputRadioCstm d-none"
        id="hereByRd1"
      />
      </template>
      <span class="radioCircleIcon line-height-1">
        <i
          class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
        ></i>
        <i
          class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
        ></i>
      </span>
      <h4
        class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
      >
        I hereby apply for membership in
        <strong class="font-weight-500"
          >Eastern Credit Union Cooperative Society
          Limited</strong
        >
        and declare that the information given in this
        Membership Application Form is true and correct.
      </h4>
    </label>
    <div
      v-for="(personal9, index) in v$.form.personal9
        .hereRadioType_one.$errors"
      :key="index"
      class="invalid-feedback"
    >
      <span v-if="personal9.$message">{{
        personal9.$message
      }}</span>
    </div>
    <p>
      I agree to abide by the terms of the account(s)
      agreement and with the Statutory Provision and bye-laws
      governing the operations of
      <strong class="font-weight-500"
        >Eastern Credit Union Cooperative Society
        Limited.</strong
      >
      I am also aware that I am not a bona fide member of the
      credit union until this application is approved by the
      Board.
    </p>
  </div>
  <div class="">
    <div class="border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="d-block">
            <label class="font-size-14"
              >Applicant’s Name</label
            >
            <input placeholder="Enter full name"
              type="text"
              v-model="form.personal9.appliname"
              class="form-control"
              disabled
            />
            <!-- Optional validation: appliname -->
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="form-group">
            <label for="sign-applicant">Applicant’s Signature</label>
            <FileUploadField
              :name="signatureName('selectedFile6')"
              @remove="removeSignature('selectedFile6')"
              @replace="onFileChange6"
            ><input
              type="file"
              accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
              @change="onFileChange6"
              class="form-control"
              id="sign-applicant"
            /></FileUploadField>
            <template v-if="isEdit">

            <img
              v-if="form.personal9.app_sign"
              :src="form.personal9.app_sign"
              class="img-custom-preview mt-3"
            />

            </template>
            <!-- Section: Applicant’s Signature Here: -->
          </div>
        </div>
      </div>
    </div>
    <template v-if="radioSelected1 === 'minor'">
      <div class="border-bottom pb-3 mb-3">
        <div class="row">
          <div class="col-lg-6 mb-3">
            <div class="d-block">
              <label class="font-size-14"
                >Name of Parent/Guardian</label
              >
              <input placeholder="Enter parent / guardian name"
                type="text"
                class="form-control"
                v-model="form.personal9.nameofparent"
                disabled
              />
              <!-- Optional validation: nameofparent -->
            </div>
          </div>

          <div class="col-lg-6 mb-3">
            <div class="form-group">
              <label for="sign-guardian"
                >Parent/ Guardian’s Signature
                <sup>(for minors)</sup></label
              >
              <FileUploadField
                :name="signatureName('selectedFile7')"
                @remove="removeSignature('selectedFile7')"
                @replace="onFileChange7"
              ><input
                type="file"
                accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                @change="onFileChange7"
                class="form-control"
                id="sign-guardian"
              /></FileUploadField>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="radioSelected1 === 'minor'">
      <div class="pb-3 mb-3">
        <div class="row">
          <div class="col-lg-6 mb-3">
            <div class="d-block">
              <label class="font-size-14"
                >Name of Trustee</label
              >
              <input placeholder="Enter trustee name"
                type="text"
                class="form-control"
                v-model="form.personal9.nameoftrustee"
                disabled
              />
              <!-- Optional validation: nameoftrustee -->
            </div>
          </div>
          <div class="col-lg-6 mb-3">
            <div class="form-group">
              <label for="sign-trustee"
                >Trustee’s Signature
                <sup>(for minors)</sup></label
              >
              <FileUploadField
                :name="signatureName('selectedFile8')"
                @remove="removeSignature('selectedFile8')"
                @replace="onFileChange8"
              ><input
                type="file"
                accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                @change="onFileChange8"
                class="form-control"
                id="sign-trustee"
              /></FileUploadField>

              <!-- Section: Trustee’s Signature Here: -->
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { bridge } from "../formBridge";
import FileUploadField from "@/components/shared/FileUploadField.vue";

export default {
  name: "DeclarationStep",
  components: { FileUploadField },
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["radioSelected1", "form"],
    methods: ["onFileChange6", "onFileChange7", "onFileChange8", "signatureName", "removeSignature"],
    validate: true,
    }),
  ],
};
</script>